import { useAtom } from 'jotai';
import { updateNetworkOrderAtom } from '../../atoms';

const useDndUtils = (order: string[]) => {
  const [, updateOrder] = useAtom(updateNetworkOrderAtom);

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (!over) return;

    const activeId = typeof active.id === 'string' ? active.id : String(active.id);
    const overId = typeof over.id === 'string' ? over.id : String(over.id);

    const sourceIdx = order.indexOf(activeId);
    const destIdx = order.indexOf(overId);

    if (sourceIdx === -1 || destIdx === -1) {
      return;
    }

    const newOrder = Array.from(order);
    const [reorderedItem] = newOrder.splice(sourceIdx, 1);
    newOrder.splice(destIdx, 0, reorderedItem);

    updateOrder(newOrder);
  };

  return { handleDragEnd };
};

export default useDndUtils;
